import axios from "../helpers/axioxInstance";
import URLS from "../constData/urls";

export const drmFlipFlag = async ([requestId, processId, sagaIds, userName, controller]) => {
  const config = controller ? { signal: controller.signal } : {};
  const response = await axios.post(
    URLS.DRM_FLIP_FLAG,
    { requestId, processId, sagaIds, userName },
    config
  );

  if (response.status >= 400) {
    throw new Error(response.message);
  }

  return response;
};
